import React from 'react'
import axios from 'axios'
import GatsbyConfig from '../../gatsby-config.js'
import { getEl, setInLocal } from '../utils/app-helpers'
import { saveData, validateRequired, validateEmail } from '../utils/forms'
import SiteFooter from '../components/partials/site-footer'
import SiteHeader from '../components/partials/site-header'

const { siteMetadata: config } = GatsbyConfig

export default class Status404Page extends React.Component {
  static BLANK_FORM_DATA = {
    message: '',
  }

  constructor() {
    super()
    this.onInputChange = this.onInputChange.bind(this)
    this.state = { isBusy: false }
  }

  componentDidMount() {
    if (typeof window === 'undefined') return
    const { trip } = this.props

    this.validateDataKeys = Object.keys(Status404Page.BLANK_FORM_DATA)
    this.liveChecking = false
  }

  onInputChange() {
    this.data = saveData('lsg.report-error-data')
    if (this.liveChecking) {
      validateRequired('lsg.report-error-data', this.validateDataKeys)
    }
  }

  submit() {
    this.data = saveData('lsg.report-error-data')
    if (!validateRequired('lsg.report-error-data', this.validateDataKeys)) {
      this.liveChecking = true
      return
    }
    const path = window.location.pathname
    const trip = path.replace(/^\/([a-z0-9]+)\/.*/i, '$1')
    const tripData = config.trips[trip] || {}
    const formEl = getEl('.report-error form')
    const endpoint = process.env.GATSBY_ENDPOINT_REPORT_ERROR
    const { protocol, hostname, port } = window.location
    const params = {
      ...this.data,
      trip,
      error: '404: Page not found',
      currentURL: window.location.href,
      referringURL: document.referrer,
      returnPathRoot: `${protocol}//${hostname}${
        port ? ':' + port : ''
      }/${trip}`,
      tripDates: tripData ? tripData.dates : '',
      tripName: tripData ? tripData.name : '',
      tripYear: tripData ? tripData.year : '',
      tripRegion: tripData ? tripData.region : '',
      tripVenue: tripData ? tripData.venue : '',
    }
    let keyPairs = []
    for (let key in params) {
      keyPairs.push(`${key}=${encodeURIComponent(params[key])}`)
    }

    formEl.classList.remove('sent', 'failed')
    this.setState({ isBusy: true })
    axios
      .post(`${endpoint}?${keyPairs.join('&')}`, {
        headers: config.axiosHeaders,
      })
      .then(function() {
        formEl.classList.add('sent')
        formEl.reset()
        setInLocal(
          'lsg.report-error-data',
          JSON.stringify(Status404Page.BLANK_FORM_DATA)
        )
      })
      .catch(function() {
        formEl.classList.add('failed')
      })
      .finally(
        function() {
          this.setState({ isBusy: false })
        }.bind(this)
      )
  }

  render() {
    let data = { ...Status404Page.BLANK_FORM_DATA }
    try {
      const raw = localStorage.getItem('lsg.report-error-data')
      if (raw) data = JSON.parse(raw)
    } catch (err) {}
    const { isBusy } = this.state

    return (
      <div className="page-at-root page-404">
        <SiteHeader trip="none" />
        <main className="report-error form">
          <form
            onSubmit={e => e.preventDefault()}
            data-sent="Thank you!"
            data-failed="Whoops. We had a problem sending your report. Please try again..."
          >
            {isBusy ? (
              <div className="loader-mask">
                <p>Sending Report</p>
                <div className="loader" />
              </div>
            ) : (
              ''
            )}
            <div className="wrap">
              <div className="content">
                <h1>Page Not Found</h1>
                <p>
                  Please let us know how you arrived here. What website did you
                  come from and, if possible, what link did you click? Your help
                  would be greatly appreciated.
                </p>
                <fieldset>
                  <p className="field">
                    <textarea
                      name="message"
                      onChange={this.onInputChange.bind(this)}
                      defaultValue={data.message}
                    />
                  </p>
                </fieldset>
                <p className="button-bar full">
                  <button className="btn-primary" onClick={e => this.submit(e)}>
                    Send Report
                  </button>
                </p>
              </div>
            </div>
          </form>
        </main>
        <SiteFooter />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/404.js